import { FilterGroup } from 'types';
import { IGetFilterGroupsProps } from '..';
import { getDaysIdleFilter } from './daysIdle/daysIdle';

export const getEngagementGroupFilters = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'ENGAGEMENT',
    filters: [getDaysIdleFilter(props)],
  };
};
